export const pl = {
  // Header & Navigation
  nav: {
    home: "Strona główna",
    shop: "Sklep",
    about: "O nas",
    contact: "Kontakt",
    login: "Zaloguj się",
    logout: "Wyloguj",
    myOrders: "Moje zamówienia",
    adminPanel: "Panel admina",
    allProducts: "Wszystkie produkty",
    powerTools: "Baterie do DeWalt",
    handTools: "Baterie do Milwaukee",
    accessories: "Baterie do Makita",
    toolsAccessories: "Narzędzia i akcesoria"
  },

  // Home Page
  home: {
    heroLabel: "Profesjonalne narzędzia",
    heroTitle1: "Zbudowane na wytrzymałość.",
    heroTitle2: "Pracuj ciężej.",
    heroDescription: "Profesjonalne narzędzia budowlane i sprzęt, którym ufają fachowcy. Zaprojektowane z myślą o wydajności i trwałości.",
    shopNow: "Kup teraz",
    learnMore: "Dowiedz się więcej",
    qualityGuaranteed: "Gwarancja jakości",
    qualityDesc: "Wszystkie produkty objęte gwarancją producenta",
    fastShipping: "Szybka dostawa",
    shippingDesc: "Darmowa dostawa przy zamówieniach powyżej 500 PLN",
    expertSupport: "Wsparcie ekspertów",
    supportDesc: "Całodobowa pomoc techniczna od profesjonalistów",
    browseLabel: "Przeglądaj",
    categories: "Kategorie",
    viewAll: "Zobacz wszystko",
    topPicks: "Najlepszy wybór",
    bestSellers: "Bestsellery",
    shopAll: "Zobacz wszystko",
    readyToBuild: "Gotowy do budowy?",
    getRightTools: "Zdobądź odpowiednie narzędzia do pracy",
    ctaDescription: "Dołącz do tysięcy profesjonalistów, którzy ufają Narzędzia Pro w swoich projektach budowlanych i remontowych. Jakościowe narzędzia, konkurencyjne ceny, profesjonalne wsparcie.",
    startShopping: "Zacznij zakupy",
    powerToolsDesc: "Oryginalne i zamienne baterie do narzędzi DeWalt",
    handToolsDesc: "Oryginalne i zamienne baterie do narzędzi Milwaukee",
    accessoriesDesc: "Oryginalne i zamienne baterie do narzędzi Makita",
    toolsAccessoriesDesc: "Profesjonalne narzędzia i akcesoria budowlane"
  },

  // Shop Page
  shop: {
    title: "Sklep",
    allProducts: "Wszystkie produkty",
    sortBy: "Sortuj według:",
    default: "Domyślnie",
    priceLowHigh: "Cena: od najniższej",
    priceHighLow: "Cena: od najwyższej",
    name: "Nazwa",
    filters: "Filtry",
    showing: "Wyświetlanie",
    products: "produktów",
    noProducts: "Nie znaleziono produktów w tej kategorii."
  },

  // Product
  product: {
    bestseller: "Bestseller",
    addToCart: "Dodaj do koszyka",
    inStock: "Dostępny",
    available: "dostępnych",
    outOfStock: "Niedostępny",
    backToShop: "Powrót do sklepu",
    features: "Cechy",
    professionalGrade: "Profesjonalna jakość",
    manufacturerWarranty: "Gwarancja producenta",
    fastDelivery: "Szybka dostawa dostępna",
    relatedProducts: "Powiązane produkty"
  },

  // Cart
  cart: {
    title: "Koszyk",
    empty: "Twój koszyk jest pusty",
    emptyDesc: "Wygląda na to, że nie dodałeś jeszcze żadnych produktów.",
    continueShopping: "Kontynuuj zakupy",
    orderSummary: "Podsumowanie zamówienia",
    subtotal: "Suma częściowa",
    shipping: "Dostawa",
    free: "Darmowa",
    addMore: "Dodaj jeszcze",
    forFreeShipping: "do darmowej dostawy",
    total: "Razem",
    proceedToCheckout: "Przejdź do kasy",
    loginToCheckout: "Zaloguj się",
    orLoginText: "lub",
    noAccount: "Nie masz konta?",
    register: "Zarejestruj się"
  },

  // Checkout
  checkout: {
    title: "Realizacja zamówienia",
    backToCart: "Powrót do koszyka",
    shippingInfo: "Informacje o dostawie",
    fullName: "Imię i nazwisko",
    streetAddress: "Adres",
    city: "Miasto",
    postalCode: "Kod pocztowy",
    phone: "Numer telefonu",
    placeOrder: "Złóż zamówienie",
    processing: "Przetwarzanie...",
    orderConfirmed: "Zamówienie potwierdzone!",
    thankYou: "Dziękujemy za zakup.",
    orderId: "Numer zamówienia:",
    viewOrders: "Zobacz zamówienia",
    items: "szt.",
    paymentMethod: "Metoda płatności",
    cashOnDelivery: "Za pobraniem",
    payOnDelivery: "Płatność przy odbiorze",
    payNow: "Zapłać teraz",
    success: "Dziękujemy za zamówienie!",
    successMessage: "Twoje zamówienie zostało przyjęte i jest przetwarzane.",
    orderNumber: "Numer zamówienia",
    paid: "Opłacone",
    pending: "Oczekuje na płatność",
    continueShopping: "Kontynuuj zakupy",
    emailRequired: "Email jest wymagany",
    deliveryMethod: "Sposób dostawy",
    inpostDesc: "24/7, odbiór w 48h",
    dpdDesc: "Dostawa pod drzwi, 1-2 dni",
    dpdPickupDesc: "Punkt odbioru DPD",
    inpostLocker: "Numer paczkomatu",
    inpostLockerRequired: "Podaj numer paczkomatu",
    findLocker: "Znajdź paczkomat na"
  },

  // Auth
  auth: {
    login: "Zaloguj się",
    register: "Zarejestruj się",
    createAccount: "Utwórz konto",
    welcomeBack: "Witaj ponownie! Wprowadź dane, aby kontynuować.",
    joinUs: "Dołącz do nas i uzyskaj dostęp do profesjonalnych narzędzi.",
    email: "Email",
    password: "Hasło",
    confirmPassword: "Potwierdź hasło",
    fullName: "Imię i nazwisko",
    loggingIn: "Logowanie...",
    creatingAccount: "Tworzenie konta...",
    noAccount: "Nie masz konta?",
    haveAccount: "Masz już konto?",
    demoCredentials: "Dane demonstracyjne administratora:"
  },

  // Contact
  contact: {
    title: "Kontakt",
    getInTouch: "Skontaktuj się",
    hereToHelp: "Jesteśmy tu, aby pomóc",
    description: "Masz pytania dotyczące naszych produktów lub potrzebujesz porady eksperta? Nasz zespół profesjonalistów jest gotowy, aby Ci pomóc.",
    phone: "Telefon",
    email: "Email",
    address: "Adres",
    hours: "Godziny pracy",
    sendMessage: "Wyślij wiadomość",
    yourName: "Twoje imię",
    message: "Wiadomość",
    howCanWeHelp: "Jak możemy Ci pomóc?",
    sending: "Wysyłanie...",
    messageSent: "Wiadomość wysłana!",
    thankYouMessage: "Dziękujemy za kontakt. Odpowiemy w ciągu 24 godzin.",
    sendAnother: "Wyślij kolejną wiadomość"
  },

  // About
  about: {
    title: "O nas",
    heroTitle1: "Stworzone przez fachowców,",
    heroTitle2: "Dla fachowców",
    ourStory: "Nasza historia",
    trustedPartner: "Zaufany partner od 2009",
    story1: "Narzędzia Pro zostało założone przez zespół profesjonalistów budowlanych, którzy byli sfrustrowani brakiem wysokiej jakości dostawców narzędzi w Polsce. Wiedzieliśmy, że musi istnieć lepszy sposób.",
    story2: "To, co zaczęło się jako mała operacja zaopatrzeniowa warsztatu, rozrosło się do jednego z najbardziej zaufanych sprzedawców profesjonalnych narzędzi w Polsce. Pozostaliśmy wierni naszym korzeniom: jakościowe produkty, uczciwe ceny i profesjonalna obsługa.",
    story3: "Dziś obsługujemy tysiące profesjonalistów w całym kraju — od niezależnych wykonawców po duże firmy budowlane. Nasze zaangażowanie w doskonałość pozostaje niezmienne.",
    whyChooseUs: "Dlaczego my",
    ourValues: "Nasze wartości",
    qualityFirst: "Jakość przede wszystkim",
    qualityDesc: "Pozyskujemy produkty tylko od zaufanych producentów, którzy spełniają nasze rygorystyczne standardy jakości. Każde narzędzie jest testowane, aby zapewnić jego działanie, gdy tego potrzebujesz.",
    expertTeam: "Zespół ekspertów",
    expertDesc: "Nasz personel to doświadczeni rzemieślnicy, którzy rozumieją Twoje potrzeby. Mówimy Twoim językiem i wiemy, co sprawdza się na placu budowy.",
    professionalGrade: "Profesjonalna klasa",
    professionalDesc: "Posiadamy narzędzia, na których profesjonaliści polegają na co dzień. Od elektronarzędzi po precyzyjne instrumenty, oferujemy marki, które udowodniły swoją wartość.",
    fastDelivery: "Szybka dostawa",
    deliveryDesc: "Czas to pieniądz na placu budowy. Oferujemy wysyłkę tego samego dnia i opcje dostawy następnego dnia, aby Twoje projekty były na bieżąco.",
    readyToStart: "Gotowy do rozpoczęcia?",
    browseSelection: "Przeglądaj nasz wybór profesjonalnych narzędzi i sprzętu. Pytania? Nasz zespół jest tutaj, aby pomóc.",
    yearsExperience: "Lat doświadczenia",
    satisfiedCustomers: "Zadowolonych klientów",
    productsCount: "Produktów",
    support: "Wsparcie"
  },

  // Orders
  orders: {
    title: "Moje zamówienia",
    account: "Konto",
    noOrders: "Brak zamówień",
    noOrdersDesc: "Nie złożyłeś jeszcze żadnych zamówień.",
    startShopping: "Zacznij zakupy",
    orderId: "Numer zamówienia",
    date: "Data",
    status: "Status",
    total: "Razem",
    shippingAddress: "Adres dostawy",
    pending: "Oczekujące",
    completed: "Zrealizowane",
    cancelled: "Anulowane",
    items: "szt."
  },

  // Admin
  admin: {
    title: "Panel admina",
    dashboard: "Panel",
    products: "Produkty",
    orders: "Zamówienia",
    contacts: "Wiadomości",
    messages: "Wiadomości",
    revenue: "Przychód",
    addProduct: "Dodaj produkt",
    importCsv: "Import CSV",
    downloadTemplate: "Pobierz szablon CSV",
    importProducts: "Importuj produkty",
    importSuccess: "Import zakończony pomyślnie",
    importError: "Błąd importu",
    productsCreated: "produktów utworzonych",
    productsFailed: "nieudanych",
    selectCsvFile: "Wybierz plik CSV",
    csvFormatInfo: "Format: nazwa, opis, cena, kategoria, url_obrazu, stan_magazynowy, bestseller",
    editProduct: "Edytuj produkt",
    createProduct: "Utwórz produkt",
    updateProduct: "Zaktualizuj produkt",
    productName: "Nazwa produktu",
    description: "Opis",
    price: "Cena (PLN)",
    stock: "Stan magazynowy",
    category: "Kategoria",
    imageUrl: "URL obrazu",
    markAsBestseller: "Oznacz jako bestseller",
    noOrders: "Brak zamówień.",
    noMessages: "Brak wiadomości.",
    shipTo: "Wyślij do:",
    contactMessages: "Wiadomości kontaktowe",
    language: "Język",
    selectAll: "Zaznacz wszystkie",
    selected: "wybrano",
    deleteSelected: "Usuń zaznaczone",
    bulkDeleteConfirm: "Czy na pewno chcesz usunąć zaznaczone produkty?",
    productsDeleted: "produktów usunięto",
    hideProduct: "Ukryj produkt",
    showProduct: "Pokaż produkt",
    hidden: "Ukryty",
    visible: "Widoczny",
    settings: "Ustawienia",
    siteSettings: "Ustawienia strony",
    contactInfo: "Dane kontaktowe",
    phone: "Telefon",
    email: "Email",
    address: "Adres",
    workingHours: "Godziny pracy",
    socialMedia: "Media społecznościowe",
    aboutUs: "O nas",
    aboutTitle: "Tytuł",
    aboutDescription: "Opis",
    aboutImage: "Zdjęcie",
    homepage: "Strona główna",
    heroTitle1: "Tytuł główny 1",
    heroTitle2: "Tytuł główny 2",
    heroDescription: "Opis główny",
    policies: "Polityki",
    shippingPolicy: "Polityka wysyłki",
    returnsPolicy: "Polityka zwrotów",
    faq: "FAQ",
    addFaq: "Dodaj pytanie",
    question: "Pytanie",
    answer: "Odpowiedź",
    polish: "Polski",
    russian: "Rosyjski",
    saveSettings: "Zapisz ustawienia",
    settingsSaved: "Ustawienia zapisane"
  },

  // Footer
  footer: {
    description: "Profesjonalne narzędzia dla profesjonalistów. Jakość, której możesz zaufać, wydajność, na którą możesz liczyć.",
    quickLinks: "Szybkie linki",
    company: "Firma",
    contact: "Kontakt",
    shopAll: "Wszystkie produkty",
    trustedBy: "Zaufany przez profesjonalistów na całym świecie",
    allRights: "Wszelkie prawa zastrzeżone.",
    terms: "Regulamin",
    privacy: "Polityka prywatności"
  },

  // Common
  common: {
    loading: "Ładowanie...",
    error: "Błąd",
    success: "Sukces",
    cancel: "Anuluj",
    save: "Zapisz",
    delete: "Usuń",
    deleteConfirm: "Czy na pewno chcesz usunąć ten produkt?",
    edit: "Edytuj",
    add: "Dodaj",
    remove: "Usuń",
    qty: "Ilość",
    price: "Cena",
    actions: "Akcje"
  }
};
